import React, { useMemo } from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';

const PeriodBarChart = ({ firstPeriodData, secondPeriodData, selectedSize }) => {
  const firstSeries = firstPeriodData?.daily_size_data || [];
  const secondSeries = secondPeriodData?.daily_size_data || [];

  const longerSeries = firstSeries.length >= secondSeries.length ? firstSeries : secondSeries;
  // Update the categories mapping
  const categories = longerSeries.map((item, index) => {
    const firstDate = firstSeries[index]?.DATE_KEY
      ? new Date(firstSeries[index].DATE_KEY)
      : null;
    const secondDate = secondSeries[index]?.DATE_KEY
      ? new Date(secondSeries[index].DATE_KEY)
      : null;

    const firstDateStr = firstDate
      ? `${firstDate.getDate()}/${firstDate.getMonth() + 1}/${firstDate.getFullYear().toString().slice(2)}`
      : '';
    const secondDateStr = secondDate
      ? `${secondDate.getDate()}/${secondDate.getMonth() + 1}/${secondDate.getFullYear().toString().slice(2)}`
      : '';

    return `${firstDateStr}\n${secondDateStr}`;
  });


  // Memoize the series data
  const { firstSeriesData, secondSeriesData } = useMemo(() => {
    return {
      firstSeriesData: firstSeries.map(item => item.size_counts[selectedSize] || 0),
      secondSeriesData: secondSeries.map(item => item.size_counts[selectedSize] || 0)
    };
  }, [firstSeries, secondSeries]); // Only recompute when period data changes

  const options = {
    chart: {
      type: 'column',
      height: 390,
      zoomType: 'x'
    },
    title: {
      text: 'Period Over Period',
      align: 'left',
      style: {
        fontSize: '18px',
        fontWeight: '500',
        color: '#001323'
      },
      margin: 30
    },
    xAxis: {
      categories,
      labels: {
        style: {
          fontSize: '11px',
          color: '#666666'
        },
        useHTML: true,
        formatter: function () {
          if (!this.value) return '';
          const dates = String(this.value).split('\n');
          return `<div style="text-align: center">
                      <div>${dates[0] || '-'}</div>
                      <div>${dates[1] || '-'}</div>
                  </div>`;
        }


      },
      lineWidth: 0,
      tickLength: 0
    },
    yAxis: {
      min: 0,
      title: {
          text: "Count",
          style: {
            fontSize: "18px",
            fontWeight: "400",
            color: "#001323",
          },
      },
      gridLineColor: "#E0E0E0",
  },
    tooltip: {
      shared: false,
      useHTML: true,
      backgroundColor: 'transparent',
      borderWidth: 0,
      shadow: false,
      padding: 0,
      formatter: function () {
        const color = this.series.color;
        const label = this.series.name === 'Current Period' ? selectedSize : selectedSize;
        return `
          <div style="
            position: relative;
            background: white;
            border: 1px solid ${color};
            border-radius: 4px;
            padding: 4px 8px;
            font-size: 12px;
            box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
          ">
            <div style="color: ${color}">${label}: ${this.y}</div>
            <div style="
              position: absolute;
              bottom: -6px;
              left: 20px;
              width: 0;
              height: 0;
              border-left: 6px solid transparent;
              border-right: 6px solid transparent;
              border-top: 6px solid ${color};
            "></div>
          </div>`;
      }
    },
    plotOptions: {
      column: {
        grouping: true,
        pointPadding: 0,
        borderWidth: 0
      }
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    scrollbar: {
      enabled: true
    },
    series: [
      {
        name: 'Previous Period',
        data: firstSeriesData,
        color: '#C0255F'
      },
      {
        name: 'Current Period',
        data: secondSeriesData,
        color: '#E66595'
      }
    ],
  };

  return (
    <div className='period-bar-chart-container'>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default PeriodBarChart;
